<template>
  <b-modal :active.sync="isModalActive" :width="640" scroll="keep" :canCancel="false" :onCancel="closeModal">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">結果データのアップロード</p>
      </header>
      <div class="card-content">
        <b-message type="is-warning">
          結果のCSVファイルに、カラム名「actual」で実績データの列を追加したファイルをアップロードしてください
          <b-field grouped position="is-right">
            <div class="control">
              <a class="button is-text"
                 href="https://s3-ap-northeast-1.amazonaws.com/dev.sx-score.models/sample/sx_score_actual_data_sample.csv"
                 style="font-size: 0.8rem;">
                        <span class="icon">
                          <i class="fas fa-file-download"></i>
                        </span>
                <span>サンプルCSVをダウンロード</span>
              </a>
            </div>
          </b-field>
        </b-message>
        <file-upload-area v-model="upload.file"
                          :is-uploading="upload.isUploading"
                          :is-disabled="upload.isDisabled"/>
      </div>
      <footer class="card-footer">
        <a class="card-footer-item" @click="closeModal">キャンセル</a>
        <a class="card-footer-item" @click="evaluateScore(transactionId)">スコアを評価</a>
      </footer>
    </div>
  </b-modal>
</template>

<script>

import FileUploadArea from './inputs/FileUploadArea'

import evaluateRequest from '../modules/request/evaluate'

export default {
  name: 'EvaluateModal',
  components: {
    'file-upload-area': FileUploadArea
  },
  props: {
    isModalActive: {type: Boolean, default: false},
    transactionId: {type: String, default: ''}
  },
  data () {
    return {
      upload: {
        file: null,
        isUploading: false,
        isDisabled: false
      }
    }
  },
  watch: {
    isModalActive () {
      this.upload.file = null
    }
  },
  methods: {
    evaluateScore () {
      if (!this.upload.file) {
        this.$toast.open({
          message: 'ファイルを選択してください',
          type: 'is-warning'
        })
        return false
      }
      evaluateRequest(this.transactionId, this.upload.file, this.$parent)
    },
    closeModal () {
      this.$parent.evaluation.isModalActive = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EvaluateModal.vue